<template>
  <div class="whiteBG">
    <div class="w1200">
      <a-breadcrumb>
        <a-breadcrumb-item><router-link to="/index">首页</router-link></a-breadcrumb-item>
        <a-breadcrumb-item><router-link to="/liveList">课程直播</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>{{ LiveDetailData.title }}</a-breadcrumb-item>
      </a-breadcrumb>

      <div class="live_cover">
        <div class="cover_box">
          <img :src="LiveDetailData.thumb" alt="" />
          <div class="glass_wrap" v-if="LiveDetailData.is_type == 1">
            <img src="../../assets/images/living_icon.png" alt="" class="livebtn" @click="goLive" />
          </div>
        </div>
        <div class="intro_box">
          <div class="intro_title">
            <div class="d_title">
              <a-tag class="newTag" v-if="LiveDetailData.is_new == 1">新客专享</a-tag>
              <a-tag class="vipTag" v-if="LiveDetailData.is_member == 1">会员专享</a-tag>
              {{ LiveDetailData.title }}
            </div>
            <div class="d_view">
              <span>
                <i class="iconfont icon-zwliulanliang"></i>
                {{ LiveDetailData.browse_num }}
              </span>
              <span>
                <i class="iconfont icon-zwbaomingrenshu"></i>
                {{ LiveDetailData.applicant_num }}
              </span>
              <a-rate v-model:value="LiveDetailData.star" allow-half disabled />
              <a href="#rate" @click="goRateAnchor" v-if="LiveDetailData.is_type == 3"><i
                  class="iconfont icon-zwxiugai2"></i></a>
              <a-tooltip>
                <template #title>
                  <img :src="LiveDetailData.xcx_img" alt="" />
                  <a-button type="primary" @click="copyUrl(LiveDetailData.offline_url, LiveDetailData.id)">复制链接</a-button>
                </template>
                <i class="iconfont icon-zwfenxiang1"></i>
              </a-tooltip>
            </div>
          </div>
          <div class="intro_details">
            <div class="time">
              <i class="iconfont icon-zwzhiboshijian"></i>
              直播时间：<span class="con">{{ LiveDetailData.date }}</span>
            </div>
            <div class="price">
              <i class="iconfont icon-zwkechengjiage"></i>
              课程价格：<span>
                <i class="price_selling">￥{{ LiveDetailData.price_selling }}</i>
                <i class="price_market" v-if="LiveDetailData.price_market != ''">￥{{ LiveDetailData.price_market }}</i>
              </span>
            </div>
            <div class="speaker">
              <i class="iconfont icon-zwkechenglaoshi"></i>
              课程老师：<span class="con">{{ 'YinoLink易诺' }}</span>
            </div>
            <div class="num">
              <i class="iconfont icon-zwfenleibiaoqian"></i>
              分类标签：<a-tag color="#3A84FF" v-for="tag in LiveDetailData.catag" :key="tag.index"
                @click="goEachTag(tag.name)">{{ tag.name }}</a-tag>
            </div>
            <div class="countdown">
              <span v-if="LiveDetailData.is_type == 2">{{ ' 距离开播' }}：<i class="countdownTime">{{ liveCount }}</i></span>
              <span v-else-if="LiveDetailData.is_type == 3">直播已经结束</span>
              <span v-else>正在直播</span>
            </div>
          </div>
          <div class="operate_box">
            <div v-if="userInfo == null" style="display: flex; justify-content: space-between">
              <a-button type="primary" size="large" block @click="applyLoginBtn"
                v-if="LiveDetailData.is_type == 2">立即预约</a-button>
              <a-button type="primary" class="success-btn" size="large" block @click="applyLoginBtn"
                v-else-if="LiveDetailData.is_type == 1">进入直播</a-button>
              <a-button type="primary" :disabled="true" size="large" style="width: 45%"
                :class="LiveDetailData.live_url == '' ? 'block_btn' : ''"
                v-else-if="LiveDetailData.is_type == 3 && LiveDetailData.is_play == 0">暂无回放</a-button>
              <a-button type="primary" size="large" style="width: 45%"
                :class="LiveDetailData.live_url == '' ? 'block_btn' : ''" @click="applyLoginBtn"
                v-else-if="LiveDetailData.is_type == 3 && LiveDetailData.is_play == 1">查看回放</a-button>
              <a-button type="primary" size="large" v-if="LiveDetailData.is_type == 3 && LiveDetailData.live_url != ''"
                :href="LiveDetailData.live_url" target="_blank" style="width: 45%">查看文章</a-button>
            </div>
            <div v-else>
              <div v-if="LiveDetailData.type == 0" style="display: flex; justify-content: space-between">
                <a-button type="primary" size="large" block v-if="LiveDetailData.is_type == 2"
                  @click="apply(0, 3)">立即预约</a-button>
                <a-button type="primary" class="success-btn" size="large" block v-else-if="LiveDetailData.is_type == 1"
                  @click="apply">进入直播</a-button>
                <a-button type="primary" :disabled="true" size="large" style="width: 45%"
                  :class="LiveDetailData.live_url == '' ? 'block_btn' : ''"
                  v-else-if="LiveDetailData.is_type == 3 && LiveDetailData.is_play == 0">暂无回放</a-button>
                <a-button type="primary" size="large"
                  v-else-if="LiveDetailData.is_type == 3 && LiveDetailData.is_play == 1" style="width: 45%"
                  :class="LiveDetailData.live_url == '' ? 'block_btn' : ''" @click="apply">查看回放</a-button>
                <a-button type="primary" size="large" v-if="LiveDetailData.is_type == 3 && LiveDetailData.live_url != ''"
                  :href="LiveDetailData.live_url" target="_blank" style="width: 45%">查看文章</a-button>
              </div>
              <div v-else-if="LiveDetailData.type == 1">
                <a-button type="primary" size="large" block @click="applyBtn">立即支付</a-button>
              </div>
              <div class="operate_btn" v-else style="display: flex; justify-content: space-between">
                <a-button type="primary" class="success-btn" size="large" block v-if="LiveDetailData.is_type == 2"
                  @click="apply1">预约成功</a-button>
                <a-button type="primary" class="success-btn" size="large" block v-else-if="LiveDetailData.is_type == 1"
                  @click="apply1">进入直播</a-button>
                <a-button type="primary" :disabled="true" size="large" style="width: 45%"
                  :class="LiveDetailData.live_url == '' ? 'block_btn' : ''"
                  v-else-if="LiveDetailData.is_type == 3 && LiveDetailData.is_play == 0">暂无回放</a-button>
                <a-button type="primary" size="large"
                  v-else-if="LiveDetailData.is_type == 3 && LiveDetailData.is_play == 1" style="width: 45%"
                  :class="LiveDetailData.live_url == '' ? 'block_btn' : ''" @click="apply1">查看回放</a-button>
                <a-button type="primary" size="large" v-if="LiveDetailData.is_type == 3 && LiveDetailData.live_url != ''"
                  :href="LiveDetailData.live_url" target="_blank" style="width: 45%">查看文章</a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w1200">
    <div class="list_content">
      <div class="dlist_left">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="直播概述">
            <div class="content" v-html="LiveDetailData.content"></div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="直播目录">
            <ul class="catalogue">
              <li v-for="item in LiveDetailData.catalog" :key="item.id" @click="goLive(item.id)">
                <div class="title">
                  <img src="@/assets/images/livedeatils_icon04.png" class="playIcon" />
                  <!-- <img src="@/assets/images/livedeatils_icon05.png" class="playIcon"> -->
                  <span class="text">{{ item.title }}</span>
                </div>
                <div class="time">开播：{{ item.open_time }}</div>
              </li>
            </ul>
          </a-tab-pane>
          <a-tab-pane key="3">
            <template #tab>
              <span>用户评论({{ LiveDetailData.comment_num }})</span>
            </template>
            <!-- 评价区域 -->
            <Evaluate :rateId="liveId" :rateType="1" />
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="list_right">
        <!-- 联系我们 -->
        <ContactYL />
        <!-- DTC独立站 -->
        <a class="DtcBanner" href="https://dwz.cn/liUeWWoA" target="_blank">
          <img src="@/assets/images/hotDtcBanner.jpeg" alt="" />
        </a>
        <!-- 热门直播 -->
        <HotLive />
        <!-- 推荐课程 -->
        <HotCourse />
      </div>
    </div>
  </div>

  <!-- 评价弹框 -->
  <RateDialog />
  <!-- 报名弹框 -->
  <ApplyDialog />
  <!-- 学习频繁问卷弹窗 -->
  <StudyQuestionDialog :open="isOpenQuestionDialog" @close="() => (isOpenQuestionDialog = false)" />
</template>

<script>
import '@/assets/css/list.less'
import '@/assets/css/details.less'
import { getIsCourse } from '@/request/api/question.js'
import RateDialog from '@/components/details/RateDialog.vue'
import Evaluate from '@/components/details/Evaluate.vue'
import ContactYL from '@/components/hot/ContactYL.vue'
import ApplyDialog from '@/components/details/ApplyDialog.vue'
import HotLive from '@/components/hot/HotLive.vue'
import HotCourse from '@/components/hot/HotCourse.vue'
import StudyQuestionDialog from '@/components/questionDialog/StudyQuestionDialog.vue'
export default {
  name: 'LiveDetails',
  components: { RateDialog, Evaluate, ContactYL, ApplyDialog, HotLive, HotCourse, StudyQuestionDialog },
  props: ['liveId'],
  data() {
    return {
      tdk: '',
      userInfo: '',
      liveCount: '',
      isFillForm: 0,
      activeKey: '1',
      LiveDetailData: {},
      bottomForm: 0,
      surveyForm: [],
      isOpenQuestionDialog: false, // 是否打开学习频繁问卷弹窗
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.getLiveDetailData()
    this.Time()
    this.$bus.on('getLiveRataTotal', (e) => {
      this.getLiveRataTotal(e.type)
    })
    this.$bus.on('apply', (e) => {
      this.apply(e.isFillForm, 0, 0, e.surveyForm)
    })
    this.$bus.on('surveyFormData1', (e) => {
      this.apply(1, 0, 0, e.surveyForm)
    })
    let goUrl = this.isMobile()
    if (goUrl === 1) {
      //移动端地址
      location = `https://acadmin.yinolink.com/lview/${this.liveId}`
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      if (navigator.userAgent.match(/pad/i)) {
        flag = false
      }
      localStorage.setItem('isMobile', flag ? 1 : 0)
      let goUrl = flag ? 1 : 0
      return goUrl
    },
    async getLiveDetailData() {
      if (this.liveId == undefined) {
        this.$router.push('/liveList')
      }
      const { data: res } = await this.$http.post('live/view', { id: this.liveId })
      this.LiveDetailData = res.data
      this.isFillForm = res.data.form
      this.tdk = res.tdk
      this.bottomForm = res.form.type
      this.$nextTick(() => {
        document.title = `${this.tdk.title}`
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.tdk.keyword)
        document.querySelector('meta[name="description"]').setAttribute('content', this.tdk.description)
      })
    },
    getLiveRataTotal(type) {
      if (type == '0') {
        this.LiveDetailData.comment_num = this.LiveDetailData.comment_num + 1
      } else {
        this.LiveDetailData.comment_num = this.LiveDetailData.comment_num - 1
      }
    },
    applyLoginBtn() {
      this.$bus.emit('openLogin')
    },
    goLive(id) {
      if (this.userInfo == null) {
        this.$bus.emit('openLogin')
      } else {
        this.checkStudyTime()
        if (this.LiveDetailData.type == 0) {
          this.apply(this.isFillForm, 1, id)
        } else {
          this.apply2(id)
        }
      }
    },
    async apply(isFillForm = 0, type = 0, id = 0, surveyForm = '') {
      if (this.LiveDetailData.is_member == 1 && this.userInfo.crm_id == 0) {
        this.$message.warning('该课程为会员专享课程')
        return
      }
      this.checkStudyTime()
      if (isFillForm == 1) {
        this.isFillForm = 1
      }
      if (this.isFillForm == 0) {
        this.$bus.emit('applyDialog', { id: this.liveId, type: 'live', isFillForm: this.isFillForm })
        return
      }
      if (this.bottomForm == 1 && surveyForm == '') {
        this.$bus.emit('applyDialog', { id: this.liveId, type: 'live', isFillForm: this.isFillForm })
        return
      }
      if (surveyForm != '') {
        this.surveyForm = surveyForm
      }
      const { data: res } = await this.$http.post('order/course_apply', {
        id: this.liveId,
        type: 'live',
        source: window.localStorage.getItem('source'),
        surveyForm: this.surveyForm,
      })
      if (res.code == 100) {
        return this.$message.warning(`${res.msg}`)
      }
      if (res.code == 300) {
        this.$message.warning('登录已失效')
        window.localStorage.clear()
        location.reload()
      }
      if (res.code == 200) {
        if (type == 1) {
          this.apply2(id)
        } else {
          this.apply1(type)
        }
      }
    },
    async apply1(type = 0) {
      this.checkStudyTime()
      const { data: res } = await this.$http.post('live/is_live', { id: this.liveId })
      if (type == 3) {
        location.reload()
      }
      if (res.code == 100) {
        return this.$message.warning(`${res.msg}`)
      }
      if (res.code == 300) {
        this.$message.warning('登录已失效')
        window.localStorage.clear()
        location.reload()
      }
      if (res.is_live == 1) {
        let routeUrl = this.$router.resolve({
          name: 'LiveRoom',
          query: {
            id: this.liveId,
            course_id: res.id,
          },
        })
        window.open(routeUrl.href, '_blank')
      } else {
        let routeUrl = this.$router.resolve({
          name: 'LivePlayback',
          query: {
            id: this.liveId,
            course_id: res.id,
          },
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    async apply2(id) {
      const { data: res } = await this.$http.post('live/is_live', { id: this.liveId, _id: id })
      if (res.code == 100) {
        return this.$message.warning(`${res.msg}`)
      }
      if (res.code == 300) {
        this.$message.warning('登录已失效')
        window.localStorage.clear()
        location.reload()
      }
      if (res.is_live == 1) {
        let routeUrl = this.$router.resolve({
          name: 'LiveRoom',
          query: {
            id: this.liveId,
            course_id: res.id,
          },
        })
        window.open(routeUrl.href, '_blank')
      } else {
        let routeUrl = this.$router.resolve({
          name: 'LivePlayback',
          query: {
            id: this.liveId,
            course_id: res.id,
          },
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    RateBtn() {
      this.$bus.emit('rateDialog')
    },
    applyBtn() {
      this.$bus.emit('applyDialog')
    },
    copyUrl(url, id) {
      this.$copyText(`https://academy.yinolink.com/liveDetails?id=${id}`).then(
        (e) => {
          this.$message.success('复制成功！')
        },
        (e) => {
          this.$message.error('暂无链接！')
        }
      )
    },
    goEachTag(title) {
      this.$router.push({
        name: 'SearchList',
        query: {
          title: title,
        },
      })
    },
    goRateAnchor() {
      if (this.userInfo == null) {
        this.$bus.emit('openLogin')
        return
      }
      this.activeKey = '3'
    },
    // 天 时 分 秒 格式化函数
    countDown(myDate) {
      let d = parseInt(myDate / (24 * 60 * 60))
      d = d < 10 ? '0' + d : d
      let h = parseInt((myDate / (60 * 60)) % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt((myDate / 60) % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(myDate % 60)
      s = s < 10 ? '0' + s : s
      this.liveCount = d + '天' + h + '时' + m + '分' + s + '秒'
    },
    //定时器每过1秒参数减1
    Time() {
      setInterval(() => {
        var myDate = parseInt(this.LiveDetailData.time - new Date().getTime() / 1000)
        myDate -= 1
        this.countDown(myDate)
      }, 1000)
    },
    // 检查用户频繁学习弹出问卷
    checkStudyTime() {
      getIsCourse().then((res) => {
        if (res.code === 200 && res.type === 1) {
          this.isOpenQuestionDialog = true
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.block_btn {
  width: 100% !important;
}

.live_cover {
  .intro_box {
    width: 387px;
    height: 488px;

    .intro_title {
      width: 100%;
      height: 120px;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      padding: 20px;

      .d_title {
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        min-height: 56px;
        line-height: 28px;
      }
    }

    .intro_details {
      width: 100%;
      height: 286px;
      background-color: #f9f9f9;
      padding: 20px;

      >div {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 24px;

        .iconfont {
          font-size: 18px;
          vertical-align: middle;
        }

        .con {
          color: rgba(0, 0, 0, 0.85);
        }

        .price_selling {
          color: #ff4d4f;
        }

        .price_market {
          text-decoration: line-through;
        }
      }

      >div:last-child {
        font-size: 18px;
      }

      .num {
        margin-bottom: 24px;
      }

      .price {
        .free {
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .countdown {
        .countdownTime {
          color: #3a84ff;
        }
      }
    }
  }
}

.list_content {
  .dlist_left {
    .catalogue {
      li {
        margin-bottom: 24px;

        div.title {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          cursor: pointer;

          .playIcon {
            width: 18px;
            height: 18px;
            margin-right: 16px;
          }

          .text {
            display: inline-block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
          }

          .text.play,
          .time.play {
            color: #3a84ff;
          }
        }

        div.time {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
}
</style>
